import { pillIconMap } from "apps/website/components/base/Pill/Pill";
import { Theme } from "apps/website/maps/Theme.map";

import {
  ILandingPageRecipeCarouselItem,
} from "../components/LandingPageRecipeCarouselItem";

const GREEN_LIGHT: Theme = "green-light";
const TEXT_WHITE = "text-white";
const BG_GRAPHITE_GREY = "bg-graphite-grey";

const getPill = (icon: keyof typeof pillIconMap, label: string) => ({
  icon,
  label,
  styleOptions: { bgColor: GREEN_LIGHT },
});

export const recipeCarouselData: ILandingPageRecipeCarouselItem[] = [
  {
    stickerProps: {
      variant: "heartPlusSticker",
    },
    title: "Crafted with love",
    description: "Our vets advise on every recipe for maximum taste and nutrition. So cats live healthier, happier lives.",
    pills: [
      getPill("tickHeavy", "Vet-approved"),
      getPill("tickHeavy", "Taste-tested"),
    ],
    theme: "light",
  },
  {
    stickerProps: {
      variant: "premiumMeatSticker",
    },
    title: "Sourced for quality",
    description: "Our nutritionists select prime cuts of the same meat that's used in human food. So your cat eats best.",
    pills: [
      getPill("tickHeavy", "100% human-grade real meat"),
      getPill("tickHeavy", "Made daily in Suffolk"),
    ],
    theme: "light",
  },
  {
    stickerProps: {
      variant: "nutritionallyBalancedSticker",
    },
    title: "Nutritionally-balanced",
    description: "Our scientists formulate and add a complete vitamin mix to every meal. For optimal health benefits.",
    pills: [
      getPill("tickHeavy", "Vitamin B12"),
      getPill("tickHeavy", "Calcium"),
      getPill("tickHeavy", "Zinc"),
      getPill("tickHeavy", "Taurine"),
    ],
    theme: "light",
  },
  {
    stickerProps: {
      variant: "gentlyCookedSticker",
    },
    title: "Gently cooked",
    description: "Our kitchen team gently heat the meals, then cool with precision. To lock in flavour and nutrition.",
    pills: [
      getPill("tickHeavy", "Cooked below 100°C"),
      getPill("tickHeavy", "Pasteurised to kill bad bacteria"),
    ],
    theme: "light",
  },
];

export const competitorRecipeCarouselData: ILandingPageRecipeCarouselItem[] = [
  {
    stickerProps: {
      variant: "crossSticker",
    },
    title: "Made “with meat”",
    description: "In certain supermarket cat foods, that means only 4% of the named meat. The rest is unspecified and low-quality.",
    textSubtitleClassName: TEXT_WHITE,
    textBodyClassName: TEXT_WHITE,
    pills: [
      getPill("crossHeavy", "4% named meat"),
      getPill("crossHeavy", "Unknown quality"),
    ],
    containerClassName: BG_GRAPHITE_GREY,
    theme: "dark",
  },
  {
    stickerProps: {
      variant: "crossSticker",
    },
    title: "Packed with derivatives",
    description: "Unspecified body parts from unspecified animals. Often pulverised, pressed or ground. For maximum industry profits.",
    textSubtitleClassName: TEXT_WHITE,
    textBodyClassName: TEXT_WHITE,
    pills: [
      getPill("crossHeavy", "Processed leftovers"),
      getPill("crossHeavy", "Random animals"),
    ],
    containerClassName: BG_GRAPHITE_GREY,
    theme: "dark",
  },
  {
    stickerProps: {
      variant: "crossSticker",
    },
    title: "Pumped with fillers",
    description: "This box would need to be much much bigger to list them all. Some are harmful, others hidden from the label entirely.",
    textSubtitleClassName: TEXT_WHITE,
    textBodyClassName: TEXT_WHITE,
    pills: [
      getPill("crossHeavy", "Grains"),
      getPill("crossHeavy", "Sugars"),
      getPill("crossHeavy", "Preservatives"),
      getPill("crossHeavy", "Nasties"),
    ],
    containerClassName: BG_GRAPHITE_GREY,
    theme: "dark",
  },
  {
    stickerProps: {
      variant: "crossSticker",
    },
    title: "Heat-blasted",
    description: "Extreme heat creates unwanted by-products, degrading essential vitamins and nutrients.",
    textSubtitleClassName: TEXT_WHITE,
    textBodyClassName: TEXT_WHITE,
    pills: [
      getPill("crossHeavy", "Vitamin loss"),
      getPill("crossHeavy", "Protein damage"),
    ],
    containerClassName: BG_GRAPHITE_GREY,
    theme: "dark",
  },
];
